import { render } from "./ProposalParticipantItem.vue?vue&type=template&id=0ec3860e&scoped=true&ts=true"
import script from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"
export * from "./ProposalParticipantItem.vue?vue&type=script&lang=ts"

import "./ProposalParticipantItem.vue?vue&type=style&index=0&id=0ec3860e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec3860e"]])

export default __exports__